import { render, staticRenderFns } from "./DxPrescriptionManager.vue?vue&type=template&id=b41e9e8a&"
import script from "./DxPrescriptionManager.vue?vue&type=script&lang=js&"
export * from "./DxPrescriptionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports